import { __assign, __read } from "tslib";
import React, { useCallback, useState } from 'react';
import { useUserID } from '../useUserID';
import { Content } from '../Content';
export function withUserID(AvatarComponent, Dialog) {
    var _a;
    var EnhancedComponent = function (props) {
        var onOpenRaw = props.onOpen, onCloseRaw = props.onClose;
        var _a = __read(useState(false), 2), visible = _a[0], setVisible = _a[1];
        var onOpen = useCallback(function () {
            setVisible(true);
            onOpenRaw === null || onOpenRaw === void 0 ? void 0 : onOpenRaw();
        }, [setVisible, onOpenRaw]);
        var onClose = useCallback(function () {
            setVisible(false);
            onCloseRaw === null || onCloseRaw === void 0 ? void 0 : onCloseRaw();
        }, [setVisible, onCloseRaw]);
        var _b = useUserID(__assign(__assign({}, props), { visible: visible, onOpen: onOpen, onClose: onClose })), avatarProps = _b.avatarProps, contentProps = _b.contentProps, dialogProps = _b.dialogProps;
        return (React.createElement(AvatarComponent, __assign({}, props, avatarProps),
            props.children,
            React.createElement(Dialog, __assign({}, dialogProps, { onClose: onClose }),
                React.createElement(Content, __assign({}, contentProps)))));
    };
    EnhancedComponent.displayName = "'withUserID(" + ((_a = AvatarComponent.displayName) !== null && _a !== void 0 ? _a : AvatarComponent) + ")'";
    return EnhancedComponent;
}
